export default __webpack_public_path__ + "static/media/Tech-Logos.84676321.svg";